import clsx from 'clsx';
import InterviewSummaryBlockCombobox from 'components/comboboxes/InterviewSummaryBlockCombobox';
import MutedText from 'components/common/MutedText';
import HubertLabel from 'components/HubertUI/HubertLabel';
import { useTranslation } from 'react-i18next';
import { ECreateQuestionMode, useQuestionEditorContext } from '../context/create-question.context';
import InTemplateInterviewSummaryBlock from './InTemplateInterviewSummaryBlock';
import { useAppDispatch, useAppSelector } from 'rtk/query/hooks';
import { selectQuestionPresentation, selectQuestionMode } from 'rtk/questionEditorSelector';
import type { TQuestionPresentation } from '@hubertai/screening-question-types';
import { updatePresentation } from 'rtk/Question.Editor.Slice';

const TemplateInterviewSummaryBlock = () => {
  const { t } = useTranslation('Questionsv2');
  const dispatch = useAppDispatch();
  const { questionId } = useQuestionEditorContext();
  const questionPresentation = useAppSelector((state) => selectQuestionPresentation(state, questionId));
  const mode = useAppSelector((state) => selectQuestionMode(state, questionId));
  if (mode === ECreateQuestionMode.InTemplateEdit) {
    return <InTemplateInterviewSummaryBlock />;
  }

  return (
    <div className={clsx('flex flex-col justify-start gap-4', 'p-1')}>
      <div className={clsx('flex flex-row justify-start gap-4', 'hubert-vertical-center')}>
        <HubertLabel className="text-sm font-medium" htmlFor="create-question-presentation-block">
          {t('summaryBlock.label')}
        </HubertLabel>
        <InterviewSummaryBlockCombobox
          id="create-question-presentation-block"
          onValueChange={(value) => {
            dispatch(
              updatePresentation({
                questionId,
                presentation: {
                  ...questionPresentation,
                  block: value,
                } as TQuestionPresentation,
              }),
            );
          }}
          value={questionPresentation.block}
        />
      </div>
      <div className="">
        <MutedText text={t('summaryBlock.hint')} />
      </div>
    </div>
  );
};

export default TemplateInterviewSummaryBlock;
